import { SxProps, Theme, Typography } from '@mui/material';

interface FieldDescriptionProps {
  description: string;
  sx?: SxProps<Theme>;
}

export default function FieldDescription({
  description,
  sx,
}: FieldDescriptionProps) {
  return (
    <Typography sx={{ ...sx, textAlign: 'left', width: '100%', color: 'text.secondary' }}>
      {description}
    </Typography>
  );
}
